var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFingerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,480c0,17.7,14.3,32,32,32s32-14.3,32-32V272H32V480z M224,320c0,17.7,14.3,32,32,32s32-14.3,32-32v-64 c0-17.7-14.3-32-32-32s-32,14.3-32,32V320z M160,384c17.7,0,32-14.3,32-32v-48c0-17.7-14.3-32-32-32s-32,14.3-32,32v48 C128,369.7,142.3,384,160,384z M320,288c0,17.7,14.3,32,32,32s32-14.3,32-32v-64c0-17.7-14.3-32-32-32s-32,14.3-32,32V288z M224,200 v0.6c9.4-5.4,20.3-8.6,32-8.6c13.2,0,25.4,4,35.6,10.8c8.7-24.9,32.5-42.8,60.4-42.8c11.7,0,22.6,3.1,32,8.6V160 C384,71.6,312.4,0,224,0h-61.7C119.8,0,79.1,16.9,49.1,46.9L37.5,58.5C13.5,82.5,0,115.1,0,149v27c0,35.3,28.7,64,64,64h88 c22.1,0,40-17.9,40-40s-17.9-40-40-40H96c-8.8,0-16-7.2-16-16s7.2-16,16-16h56C191.8,128,224,160.2,224,200z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerIcon);
export default __webpack_public_path__ + "static/media/finger_Icon.880799a024d4d097477fb60d344fd8d8.svg";
export { ForwardRef as ReactComponent };